import React from "react";
import "./Dot.scss";

const Dot = () => {
  return <p className="dot"> </p>;
};

export default Dot;
